import makeStyles from '@mui/styles/makeStyles'

export const useHeaderCellStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    background: 'transparent',
    padding: theme.spacing(2),
    lineHeight: 1,
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: 'bold',
    fontSize: theme.typography.body1.fontSize,
    borderBottomWidth: 1,
    borderBottomColor: theme.palette.primary.main,
    borderBottomStyle: 'solid'
  }
}))

export default makeStyles(theme => ({
  tableContainer: {
    minWidth: '800px',
    marginTop: theme.spacing(2),
    borderWidth: 1,
    borderColor: theme.colors.main200,
    borderStyle: 'solid',
    padding: theme.spacing(2),
    borderRadius: '4px'
  },

  classificationName: {
    width: '100%',
    marginBottom: '24px',

    '& label': {
      textAlign: 'left',
      fontSize: '1rem'
    },

    '& div': {
      width: '100%'
    }
  },

  expireDate: {
    marginBottom: '24px'
  },

  spanRed: {
    color: '#cc0000'
  }
}))
